/**
 * Check if the map container is currently visible.
 * @returns {boolean}
 */
export default function isMapRendered() {
    const mapContainer = document.getElementById('map')
    if (!mapContainer) {
        return false
    }
    const { width, height } = mapContainer.getBoundingClientRect()
    return !!(width && height)
}
